import type { MouseEvent as ReactMouseEvent } from 'react';

const OWN_CLICK_COLUMNS = [
  'leadTime',
  'approvalState',
  'source',
  'revisedCost',
  'contractNumber',
  'ppv',
  'poLineComment',
]
  .map((id) => `[data-column-id="${id}"]`)
  .join(', ');

export function shouldOpenAssignmentLine(target: EventTarget | null): boolean {
  if (!(target instanceof Element)) return true;
  // These cells own their clicks: the lead-time popover, the approval state
  // menu, which must change the state without selecting the line, the
  // source picker and the buy-terms inputs.
  return target.closest(OWN_CLICK_COLUMNS) == null;
}

function isTextEntryTarget(target: EventTarget | null): boolean {
  if (!(target instanceof Element)) return false;
  return (
    target.closest('input, textarea, select, [contenteditable="true"]') != null
  );
}

/**
 * Stop the browser from painting a shift-click text range, or a Ctrl-click
 * cell selection (Firefox), over the board.
 */
export function preventAssignmentLineModifierSelect(
  event: ReactMouseEvent<HTMLTableRowElement>,
): void {
  if (!event.shiftKey && !event.ctrlKey && !event.metaKey) return;
  if (!shouldOpenAssignmentLine(event.target)) return;
  if (isTextEntryTarget(event.target)) return;
  event.preventDefault();
  window.getSelection()?.removeAllRanges();
}
